export enum ActiveFilterEnum {
    ADVERTISEMENT = 'advertisement',
    RENT = 'rent',
    TENDER = 'tender',
    AUCTION = 'auction',
    COOPERATIVE = 'cooperative',
    BAILIFF_NOTICE = 'bailiff_notice'
  }
